export enum PumpSensorOptionEnum {
  CIR_PUMP = 'cir_pump',
  ROOM_PUMP = 'room_pump',
  BUFFER_PUMP = 'buffer_pump',
  BOILER_PUMP = 'boiler_pump',
  SOLAR_PUMP_PRIMARY = 'solar_pump_primary',
  SOLAR_PUMP_SECONDARY = 'solar_pump_secondary',
  HOT_WATER_CHARGING_PUMP = 'hot_water_charging_pump',
  HEAT_PUMP = 'heat_pump',
  WARM_WATER_PUMP = 'warm_water_pump',
}
